// extracted by mini-css-extract-plugin
export default {"overviewSVG":"MessageParserDocs_overviewSVG__zH8N7","infoBoxParagraph":"MessageParserDocs_infoBoxParagraph__00rua"};